import React from 'react';
import '../styles/main.scss';
import { BasicDetailsModel } from '../models/BasicDetails';

interface BasicDetailsProps {
  data?: BasicDetailsModel;
  onSubmit: (data: BasicDetailsModel) => void;
}

class BasicDetails extends React.Component<BasicDetailsProps, BasicDetailsModel> {
  constructor(props: BasicDetailsProps) {
    super(props);
    this.state = props.data || {
      Name: '',
      FatherName: '',
      MotherName: '',
      DOB: '',
      Gender: '',
      Address: '',
      City: '',
      State: '',
      Pincode: '',
      Mobile: '',
      Email: '',
      Age: 0,
      AdhaarNumber: '',
      PANNumber: ''
    };
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    const updates: any = {
      [name]: name === 'Age' ? Number(value) : value
    };

    if (name === 'DOB' && value) {
      const today = new Date();
      const [bYear, bMonth, bDay] = value.split('-').map(Number);
      let age = today.getFullYear() - bYear;
      const m = today.getMonth() - (bMonth - 1);
      if (m < 0 || (m === 0 && today.getDate() < bDay)) {
        age--;
      }
      updates.Age = age > 0 ? age : 0;
    }

    this.setState(updates as unknown as Pick<BasicDetailsModel, keyof BasicDetailsModel>);
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    this.props.onSubmit(this.state);
  };

  render() {
    const { Name, FatherName, MotherName, DOB, Gender, Address, City, State, Pincode, Mobile, Email, Age, AdhaarNumber, PANNumber } = this.state;

    return (
      <div className="registration-container">
        <h2 className="form-heading">મૂળભૂત વિગતો</h2>
        <form className="form-grid" onSubmit={this.handleSubmit}>
          <div>
            <label className="text-muted">પૂરું નામ</label>
            <input
              type="text"
              name="Name"
              value={Name}
              onChange={this.handleChange}
              placeholder="તમારું પૂરું નામ લખો"
              required
            />
          </div>

          <div>
            <label className="text-muted">પિતાનું નામ</label>
            <input
              type="text"
              name="FatherName"
              value={FatherName}
              onChange={this.handleChange}
              placeholder="પિતાનું નામ લખો"
              required
            />
          </div>

          <div>
            <label className="text-muted">માતાનું નામ</label>
            <input
              type="text"
              name="MotherName"
              value={MotherName}
              onChange={this.handleChange}
              placeholder="માતાનું નામ લખો"
              required
            />
          </div>

          <div>
            <label className="text-muted">ઈમેલ</label>
            <input
              type="email"
              name="Email"
              value={Email}
              onChange={this.handleChange}
              placeholder="example@email.com"
              required
            />
          </div>

          <div>
            <label className="text-muted">મોબાઈલ નંબર</label>
            <input
              type="tel"
              name="Mobile"
              value={Mobile}
              onChange={this.handleChange}
              placeholder="10 અંકનો મોબાઈલ નંબર"
              pattern="[0-9]{10}"
              required
            />
          </div>

          <div>
            <label className="text-muted">જન્મ તારીખ</label>
            <input
              type="date"
              name="DOB"
              value={DOB}
              onChange={this.handleChange}
              required
            />
          </div>

          <div>
            <label className="text-muted">ઉંમર</label>
            <input
              type="number"
              name="Age"
              value={Age || ''}
              onChange={this.handleChange}
              placeholder="ઉંમર"
              required
              readOnly
            />
          </div>

          <div>
            <label className="text-muted">લિંગ</label>
            <select
              name="Gender"
              value={Gender}
              onChange={this.handleChange}
              required
              className="form-select"
            >
              <option value="">પસંદ કરો</option>
              <option value="male">પુરુષ</option>
              <option value="female">સ્ત્રી</option>
              <option value="other">અન્ય</option>
            </select>
          </div>

          <div>
            <label className="text-muted">સરનામું</label>
            <textarea
              name="Address"
              value={Address}
              onChange={this.handleChange}
              rows={4}
              placeholder="તમારું સરનામું અહીં લખો"
              required
            />
          </div>

          <div>
            <label className="text-muted">શહેર</label>
            <input
              type="text"
              name="City"
              value={City}
              onChange={this.handleChange}
              placeholder="શહેર"
              required
            />
          </div>

          <div>
            <label className="text-muted">રાજ્ય</label>
            <input
              type="text"
              name="State"
              value={State}
              onChange={this.handleChange}
              placeholder="રાજ્ય"
              required
            />
          </div>

          <div>
            <label className="text-muted">પીનકોડ</label>
            <input
              type="text"
              name="Pincode"
              value={Pincode}
              onChange={this.handleChange}
              placeholder="પીનકોડ"
              pattern="[0-9]{6}"
              required
            />
          </div>

          <div>
            <label className="text-muted">આધાર નંબર</label>
            <input
              type="text"
              name="AdhaarNumber"
              value={AdhaarNumber}
              onChange={this.handleChange}
              placeholder="આધાર નંબર"
              pattern="[0-9]{12}"
              required
            />
          </div>

          <div>
            <label className="text-muted">પાન નંબર</label>
            <input
              type="text"
              name="PANNumber"
              value={PANNumber}
              onChange={this.handleChange}
              placeholder="પાન નંબર"
              pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}"
              required
            />
          </div>

          <button type="submit" className="form-btn form-btn-submit">
            આગળ વધો
          </button>
        </form>
      </div>
    );
  }
}

export default BasicDetails;